<!--
  a11y: aria-haspopup="dialog" reflects whether activating this row opens a
  dialog rather than just picking the existing address:
    - alwaysOpensPopup=true (manage-favorites): both rows always open an edit dialog.
    - alwaysOpensPopup=false (address autocomplete feed): only rows whose favorite
      isn't set yet open a setup dialog; set rows just pick the address and close.
-->
<div class="flex flex-col gap-2">
  <app-address-auto-complete-result [address]="favoriteAddresses?.homeAddress" icon="home" [main]="homeText"
    [sub]="favoriteAddresses?.homeAddress?.addressDetails.label ?? setHomeText"
    [ariaHasPopup]="(alwaysOpensPopup || !favoriteAddresses?.homeAddress?.addressDetails.label) ? 'dialog' : null"
    (onResultClick)="onHomeClick.emit($event)" [isSubBlue]="favoriteAddresses?.homeAddress?.addressDetails.label ? false : true"/>
  <app-address-auto-complete-result [address]="favoriteAddresses?.workAddress" icon="briefcase" [main]="workText"
    [sub]="favoriteAddresses?.workAddress?.addressDetails.label ?? setWorkText"
    [ariaHasPopup]="(alwaysOpensPopup || !favoriteAddresses?.workAddress?.addressDetails.label) ? 'dialog' : null"
    (onResultClick)="onWorkClick.emit($event)" [isSubBlue]="favoriteAddresses?.workAddress?.addressDetails.label ? false : true"/>
</div>